"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _layout = require("@berlitz/globals/lib/components/layout");
var _typography = require("@berlitz/globals/lib/components/typography");
var _reactStyledFlexboxgrid = require("react-styled-flexboxgrid");
var _stripUnit = _interopRequireDefault(require("polished/lib/helpers/stripUnit"));
var _style = require("./style");
var _styledComponents = require("styled-components");
var _resizeImage = _interopRequireDefault(require("@berlitz/max-utils/lib/resizeImage"));
var _isExternalLink = _interopRequireDefault(require("@berlitz/max-utils/lib/isExternalLink"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var BlockLogoCarousel = function BlockLogoCarousel(_ref) {
  var backgroundColor = _ref.backgroundColor,
    disablePaddingBottom = _ref.disablePaddingBottom,
    disablePaddingTop = _ref.disablePaddingTop,
    images = _ref.images,
    size = _ref.size,
    subtitle = _ref.subtitle,
    theme = _ref.theme,
    title = _ref.title;
  var settings = {
    // Default Settings
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    slidesToShow: images.length < 5 ? images.length : 5,
    infinite: images.length < 3,
    responsive: [{
      breakpoint: (0, _stripUnit.default)(theme.breakpoints.lg),
      settings: {
        slidesToShow: images.length < 4 ? images.length : 4
      }
    }, {
      breakpoint: (0, _stripUnit.default)(theme.breakpoints.md),
      settings: {
        slidesToShow: images.length < 3 ? images.length : 3
      }
    }, {
      breakpoint: (0, _stripUnit.default)(theme.breakpoints.sm),
      centerMode: true,
      settings: {
        slidesToShow: images.length < 2 ? images.length : 2
      }
    }]
  };
  return /*#__PURE__*/_react.default.createElement(_layout.Section, {
    backgroundColor: backgroundColor,
    disablePaddingBottom: disablePaddingBottom,
    disablePaddingTop: disablePaddingTop,
    size: size
  }, /*#__PURE__*/_react.default.createElement(_layout.Grid, null, /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Row, {
    center: "lg"
  }, /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Col, {
    xs: 12,
    lg: 10
  }, (title || subtitle) && /*#__PURE__*/_react.default.createElement(_typography.TextAlign, {
    align: "center"
  }, title && /*#__PURE__*/_react.default.createElement(_typography.H2, {
    "data-key": "logo-carousel__title"
  }, title), subtitle && /*#__PURE__*/_react.default.createElement(_style.SubText, {
    size: "sm",
    "data-key": "logo-carousel__subtitle"
  }, subtitle)), /*#__PURE__*/_react.default.createElement(_style.StyledSlider, _extends({}, settings, {
    "data-key": "logo-carousel__slider"
  }), images.map(function (image) {
    var src = (0, _resizeImage.default)(image.src, 'auto', 150, {
      crop: false
    }); // Image with link

    if (image !== null && image !== void 0 && image.href && image !== null && image !== void 0 && image.src) {
      return /*#__PURE__*/_react.default.createElement(_style.LogoContainer, {
        key: image.src,
        "data-key": "logo-carousel__logo"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: image.href,
        target: (0, _isExternalLink.default)(image.href) ? '_blank' : '_self',
        rel: "noopener noreferrer"
      }, /*#__PURE__*/_react.default.createElement(_style.Logo, {
        src: src,
        alt: image.alt,
        "data-key": "logo-carousel__logo-image",
        loading: "lazy"
      })));
    } // Image with no link

    return /*#__PURE__*/_react.default.createElement(_style.LogoContainer, {
      key: image.src,
      "data-key": "logo-carousel__logo"
    }, /*#__PURE__*/_react.default.createElement(_style.Logo, {
      src: src,
      alt: image.alt,
      "data-key": "logo-carousel__logo-image",
      loading: "lazy"
    }));
  }))))));
};
BlockLogoCarousel.defaultProps = {
  backgroundColor: null,
  size: 'lg',
  images: []
};
var _default = (0, _styledComponents.withTheme)(BlockLogoCarousel);
exports.default = _default;